export default {
    list: {
        title: "Products",
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        name: 'products',
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                method: true,
                name: "Actions",
                buttons: [
                    {
                        text: "New Product",
                        icon: "add",
                        action:"addPrd",
                        link: '/products/new',
                        color: 'primary'
                    },
                    {
                        text: "Add & Sub Qte",
                        icon: "import_export",
                        action:"addqte",
                        color: 'primary',
                        class:''
                    },
                ],
            }
        },
        columns: [
            {
                type:"checkbox",
                elements: [{
                   items: [{
                       class: "",
                       type: "checkbox",
                   }, ],
               }, ]
            },
            {
                name: "ID",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "id",
                        type: "text",

                    }, ],
                }, ]
            },
            {
                name: "Seller",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "seller",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Name",
                elements: [{
                    items: [{
                        class: "",
                        name: "name",
                        type: "text",
                    }, ],
                }, ]
            },
            // {
            //     name: "Code",
            //     elements: [{
            //         items: [{
            //             class: "",
            //             name: "code",
            //             type: "text",
            //         }, ],
            //     }, ]
            // },
           
            {
                name: "Quantity in stock",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "inStock",
                        arrayD: "details",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Quantity total",
                class: "",
                elements: [{
                    items: [{
                       class: "",
                        name: "total",
                        arrayD: "details",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Quantity defective",
                class: "",
                elements: [{
                    items: [{
                       class: "",
                        name: "defective",
                        arrayD: "details",
                        type: "text",
                    }],
                }, ]
            },
            // {
            //     name: "price",
            //     class: "",
            //     elements: [{
            //         items: [{
            //             class: "",
            //             name: "price",
            //             arrayD: "details",
            //             type: "text",
            //         }],
            //     }, ]
            // },
            // {
            //     name: "Up-sell",
            //     class: "",
            //     elements: [{
            //         items: [{
            //             class: "",
            //             name: "upsells",
            //             arrayD: "details",
            //             type: "text",
            //         }],
            //     }, ]
            // },
            {
        name: "Up-sell",
        class: "",
        elements: [
          {
            items: [
              {
                class: "",
                name: "upsells",
                arrayD: "details",
                type: "text",
              },
            ],
          },
        ],
      },
      {
        name: "Cross-sell",
        class: "",
        elements: [
          {
            items: [
              {
                class: "",
                name: "cross-sell",
                arrayD: "details",
                type: "text",
              },
            ],
          },
        ],
      },
            {
                name: "status",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "outOfStock",
                        arrayD: "details",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Date added",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "createdAt",
                        type: "text",
                    }],
                }, ]
            },
          
        ],
        actions: {
            name: "Actions",
            width: "10px",
            class: "rounded-full flex justify-center items-center focus:outline-none w-8 h-8 mr-3 mt-1",
            elements: [{
                    icone: "remove_red_eye",
                    color: "danger",
                    role: true,
                    key: 'read',
                    link: '/products/detail',
                    tooltip: "View",
                },
                {
                    icone: "edit",
                    color: "success",
                    role: true,
                    key: 'update',
                    link: '/products/edit',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'products',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "Id, Name product, code ...."
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [{
                        label: "Seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Price",
                        key: "price",
                        value: null,
                        placeholder: "price",
                        class: 'py-2 text-xs  px-2  outline-none block h-full w-full',
                        type: "number",
                        min: 0,
                    },
                    {
                        label: "Quantity",
                        key: "quantity",
                        value: null,
                        placeholder: "quantity",
                        type: "number",
                        class: 'py-2 text-xs  px-2  outline-none block h-full w-full',
                        min: 0,
                    },
                    {
                        label: "Date",
                        key: "date",
                        value: null,
                        placeholder: "Date",
                        type: "date",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                ],
            },
        },
    },
}